/**
 * `pattern.pulseLine` (tokens.json) — the thin ambient progress rule under a
 * page header. 2px height, fill hue.primary.vivid at 90% alpha fading to
 * transparent left-to-right, radius.pill. Purely decorative (aria-hidden);
 * the page it sits under carries its own accessible progress semantics
 * elsewhere (e.g. the percentage ring's aria-label).
 */
export function PulseLine({ scale = 'full' }: { readonly scale?: 'full' | 'footer' }) {
  return (
    <div
      aria-hidden="true"
      style={{
        height: 'var(--pattern-pulseline-height)',
        width: scale === 'footer' ? '96px' : '100%',
        borderRadius: 'var(--radius-pill)',
        background:
          'linear-gradient(90deg, var(--hue-primary-vivid), transparent)',
        opacity: 'var(--pattern-pulseline-fill-alpha)',
      }}
    />
  );
}
